import { jsonParse } from '$shared';
import DateComponent from './Date.svelte';
import Email from './Email.svelte';
import File from './File.svelte';
import Phone from './Phone.svelte';
import Rating from './Rating.svelte';
import Select from './Select.svelte';
import Text from './Text.svelte';

const phone =
  /^^((8|\+374|\+994|\+995|\+375|\+7|\+380|\+38|\+996|\+998|\+993)[- ]?)?\(?\d{3,5}\)?[- ]?\d{1}[- ]?\d{1}[- ]?\d{1}[- ]?\d{1}[- ]?\d{1}(([- ]?\d{1})?[- ]?\d{1})?$/;
const email =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validations = {
  'fields.tekst': (value, pattern) => (pattern ? new RegExp(pattern).test(value) : !!value),
  'fields.data': value => !isNaN(new Date(value)),
  'fields.fajly': value => value?.size > 0,
  'fields.telefon': value => new RegExp(phone).test(value),
  'fields.pochta': value => new RegExp(email).test(value),
  'fields.rejting': value => value > 0 && value < 6,
  'fields.vybor': (value, type) =>
    type === 'multiselect' || type === 'select' ? (jsonParse(value)?.length ?? 0) > 0 : !!value,
};

export const validate = (formData, fields) => {
  let flag = true;
  const remove = [];
  for (const [key, value] of formData.entries()) {
    const [name, type] = key.split(':');
    const field = fields?.filter(field => field.key === name)[0];
    const validation = (validations[type] ?? (value => !!value)).bind(null, value);

    let status = true;
    if (type === 'fields.vybor') status = validation(field.type);
    else if (type === 'fields.tekst') status = validation(field.pattern);
    else status = validation();

    if (!status && field && !field.required) {
      remove.push(key);
      continue;
    }
    if (!status) {
      [...document.querySelectorAll(`*[name="${key}"]`)].forEach(node => {
        if (type === 'fields.fajly') node = node.parentElement;
        else if (type === 'fields.vybor' && field.type !== 'input') node = node.parentElement.parentElement;
        node.setAttribute('input-validation', 'error');
      });
    }

    flag &= status;
  }

  remove.map(key => formData.delete(key));
  return flag;
};

export default {
  'fields.tekst': Text,
  'fields.pochta': Email,
  'fields.data': DateComponent,
  'fields.fajly': File,
  'fields.telefon': Phone,
  'fields.vybor': Select,
  'fields.rejting': Rating,
};
